import { parsePhoneNumberFromString } from "libphonenumber-js"; // Import da API que formata qualquer número

export function formatPhoneNumber(phone?: string): string {
  if (!phone) return ""; // Se for undefined ou null, retorna vazio

  const phoneNumber = parsePhoneNumberFromString(phone);
  return phoneNumber ? phoneNumber.formatInternational() : phone;
}

export function numberPadrao(numero?: string): string {
  if (!numero) return ""; // Retorna string vazia se for null, undefined ou vazio

  // Se o número começar com "+", mantém o "+" e remove os outros caracteres não numéricos
  if (numero.startsWith("+")) {
    let celularLimpo = numero.slice(1).replace(/\D/g, ""); // Remove caracteres não numéricos após o "+"
    return `+${celularLimpo}`;
  }

  // Se o número não começar com "+", remove todos os caracteres não numéricos e adiciona o "+"
  let celularLimpo = numero.replace(/\D/g, "");
  return `+${celularLimpo}`;
}
